import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-loans-payments',
  templateUrl: './loans-payments.component.html',
  styleUrls: ['./loans-payments.component.scss']
})
export class LoansPaymentsComponent implements OnInit {

  loading: any;
  date:any;
  installments: any;
  installmentEdit: any;

  paymentEdit: any;
  editPayForm: FormGroup;
  missingFieldMsg = false;
  errorMsg = false;
  @ViewChild('closeBtn') closeBtn: ElementRef;

  constructor(private appComp: AppComponent, private authService: AuthenticationService, private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    // let date = new Date();
    // let month = date.getMonth();
    // this.date = date.getFullYear() + "-" + month;
    this.editPayForm = this.formBuilder.group({
      reference: [""],
      paid: ["", Validators.required],
    });
    this.getInstallmentes();
  }

  getInstallmentes(){
    let date = new Date(this.date);
    let month = date.getMonth() + 2;
    console.log(month);
    let dateInstallments = date.getFullYear() + "-" + month;

    this.loading = true;
    this.authService.getLoanContracts().then((res:any)=>{
      res = res.map((x:any) => {
        let amortization = JSON.parse(x.amortization);
        // console.log(amortization);
        let selectDateAmortization = amortization.filter((y:any)=>
        {
          let monthPayment = new Date(y.thisDate).getMonth() + 1;
          let date = new Date(y.thisDate).getFullYear() + "-" + monthPayment;
          if(date == dateInstallments){
            return y;
          } 
        });
        // console.log(selectDateAmortization);
        let installment = {
          amortization: selectDateAmortization[0],
          contractId: x.id,
          solicitante: JSON.parse(x.solicitante),
          contract: x
        };
        return installment;
      })
      console.log(res);

      this.installments = res.filter((x:any)=> x.amortization);
      console.log(this.installments);
      this.loading = false;
    }, (err:any)=>{
      console.log(err);
      this.loading = false;
    })
  }

  markPaid(payment:any){
    console.log(payment);
    this.paymentEdit = payment;
    if(this.paymentEdit){
      this.editPayForm.patchValue({
        reference: this.paymentEdit.reference,
        paid: this.paymentEdit.paid
      })
    }
  }

  editPayment(){
    this.appComp.loading = true;
    this.missingFieldMsg = false;
    if (this.editPayForm.invalid) {
      this.missingFieldMsg = true;
      this.appComp.loading = false;
      return;
    }
    let formObj = this.editPayForm.getRawValue();
    this.paymentEdit.reference = formObj.reference;
    console.log(formObj);
    this.paymentEdit.paid = formObj.paid;
    // if(typeof formObj.active == "string"){
    //   formObj.active = formObj.active == 'true' ? true : false;
    // }

    let contract = {
      ...this.paymentEdit.contract
    }
    contract.amortization = JSON.parse(contract.amortization);

    contract.amortization = contract.amortization.map((x:any)=>{
      if(x.installmentNo == this.paymentEdit.amortization.installmentNo){
        return {
          ...x,
          ...formObj
        }
      } else return x
    })

    
    contract.amortization = JSON.stringify(contract.amortization);
    console.log(contract);
    this.authService.updateLoanContract(contract).then(res=>{
      console.log(res);
      this.closeBtn.nativeElement.click();
      this.appComp.loading = false;
      this.getInstallmentes();
      // this.router.navigateByUrl('/contracts');
    }, err=>{
      console.log(err);
      this.appComp.loading = false;
      this.errorMsg = true;
    })


    // console.log(this.paymentEdit);
    this.appComp.loading = false;

  }

}
